import { render, staticRenderFns } from "./OpportunityDashboardView.vue?vue&type=template&id=d009d824&scoped=true&"
import script from "./OpportunityDashboardView.vue?vue&type=script&lang=js&"
export * from "./OpportunityDashboardView.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityDashboardView.vue?vue&type=style&index=0&id=d009d824&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d009d824",
  null
  
)

export default component.exports